var _circle, _circle2, _g, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateDefault(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130,
    fill: "#E8F0FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15305_2242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 260,
    height: 260
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 130,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15305_2242)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.531,
    cy: 180.347,
    rx: 71.4948,
    ry: 17.1844,
    fill: "url(#paint0_linear_15305_2242)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.099 85.8398L201.358 109.503V169.292C201.358 173.462 196.912 176.126 193.235 174.16L157.099 154.84V85.8398Z",
    fill: "#63A4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.099 85.8398L201.358 109.503V169.292C201.358 173.462 196.912 176.126 193.235 174.16L157.099 154.84V85.8398Z",
    fill: "url(#paint1_linear_15305_2242)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.192 85.8501L53.8252 109.513V171.587C53.8252 175.133 57.1206 177.759 60.577 176.968L157.192 154.85V85.8501Z",
    fill: "#A9CDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.534 66.6494C140.206 65.0265 138.073 64.296 136.029 64.7639L44.677 85.6765C40.6841 86.5906 39.0426 91.3821 41.6363 94.5526L53.7319 109.338L157.099 85.6751L141.534 66.6494Z",
    fill: "#CBE1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9922 202L56.6504 179.897C54.8543 178.937 53.7329 177.066 53.7329 175.029V109.337L97.9922 133V202Z",
    fill: "#CBE1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1355 146.203C81.4073 147.739 78.9049 148.035 76.8659 146.945L42.9833 128.83C39.5958 127.019 39.0478 122.388 41.919 119.836L53.7319 109.337L97.9912 133L83.1355 146.203Z",
    fill: "#F2F7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.358 109.337L157.099 85.6745L171.954 72.4713C173.683 70.9353 176.185 70.6392 178.224 71.7293L212.107 89.8444C215.494 91.6554 216.042 96.2866 213.171 98.8383L201.358 109.337Z",
    fill: "#A9CDFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9902 202L197.069 179.319C199.578 178.745 201.357 176.513 201.357 173.939V109.337L97.9902 133V202Z",
    fill: "#A0C8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9902 133.332L201.357 109.669L212.603 121.81C215.488 124.925 213.924 129.995 209.785 130.942L118.835 151.762C116.909 152.203 114.895 151.582 113.553 150.133L97.9902 133.332Z",
    fill: "#7DB3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9902 133.332L201.357 109.669L212.603 121.81C215.488 124.925 213.924 129.995 209.785 130.942L118.835 151.762C116.909 152.203 114.895 151.582 113.553 150.133L97.9902 133.332Z",
    fill: "url(#paint2_linear_15305_2242)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15305_2242",
    x1: 81.0366,
    y1: 180.347,
    x2: 224.026,
    y2: 180.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669914,
    stopColor: "#62A3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#4B8BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2474E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15305_2242",
    x1: 155.5,
    y1: 84,
    x2: 162,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0385559,
    stopColor: "#1F4C8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63A4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15305_2242",
    x1: 185.5,
    y1: 113,
    x2: 178,
    y2: 134.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#317ADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EB4FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDefault);
export default __webpack_public_path__ + "static/media/empty-state-default.ae0ab3a7.svg";
export { ForwardRef as ReactComponent };